export default function (question, text, type, buttons, allowClose) {
  if (buttons === undefined || !Array.isArray(buttons)) {
    // eslint-disable-next-line no-param-reassign
    buttons = [
      {
        type: 'no',
        name: 'Nee',
      },
      {
        type: 'yes',
        name: 'Ja',
      },
    ];
  }

  const confirm = this.$root.$children[0].$refs.confirm;

  confirm.title =
    question === undefined || typeof question !== 'string'
      ? 'missing title'
      : question;
  confirm.content = text;
  confirm.type =
    type === undefined || typeof type !== 'string' ? 'warning' : type;
  confirm.actions = buttons;
  confirm.open = true;

  return new Promise((resolve) => {
    confirm.$off('close');
    confirm.$on('close', () => {
      if (allowClose) {
        confirm.open = false;
        confirm.$off('close');
        resolve('close');
      }
    });

    confirm.$off('action');
    confirm.$on('action', (test) => {
      confirm.open = false;
      confirm.$off('action');
      resolve(test);
    });
  });
}
